// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3nMZa","buttons":"SendReceipts_buttons__3vFCD","email":"SendReceipts_email__1Z5Ga","bookApptTitle":"SendReceipts_bookApptTitle__1hDwo"};